import { render, staticRenderFns } from "./RadarCriticalCards.vue?vue&type=template&id=5605acd1&scoped=true"
import script from "./RadarCriticalCards.vue?vue&type=script&lang=js"
export * from "./RadarCriticalCards.vue?vue&type=script&lang=js"
import style0 from "./RadarCriticalCards.vue?vue&type=style&index=0&id=5605acd1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5605acd1",
  null
  
)

export default component.exports